var testimonialsInterval,
	autoSlideTestimonials,
	currentTestimonial = 0,
	testimonialsSection = document.querySelector('section.testimonials, section.testimonial_cards'),
	intervalTime = testimonialsSection && testimonialsSection.classList.contains('testimonials') ? 7000 : 5000,
	testimonialsSlider = document.querySelector('.testimonial-cards-container'),
	testimonials = testimonialsSection ? testimonialsSection.querySelectorAll('.testimonial, .testimonial-card') : false,
	testimonialsLength = testimonials ? (testimonials.length-1) : 0,
	testimonialButtons = document.querySelectorAll('.testimonials-controller button');

if(testimonials.length > 1) {
	var testimonialsWaypoint = new Waypoint({
		element: testimonialsSection,
		handler: function(direction) {
			testimonialsInterval = setInterval(autoSlideTestimonials, intervalTime);

			this.destroy();
		},
		offset: '100%'
	});

	autoSlideTestimonials = function() {
		setCurrentTestimonial('next');
	};

	[].slice.call(testimonialButtons).forEach(function(button) {
		button.addEventListener('click', function() {
			setSliderInterval(this.className);
		});
	});
}

document.addEventListener('keydown', function(e) {
	if(testimonialsSection) {
		var activeElement = document.activeElement;

		if(activeElement.classList.contains('prev') || activeElement.classList.contains('next')) {
			var key = e.key,
				direction = key == 'ArrowRight' ? 'next' : (key == 'ArrowLeft' ? 'prev' : '');

			if(direction && testimonialsSection.contains(activeElement)) {
				setSliderInterval(direction);
				testimonialsSection.querySelector('button.'+direction).focus();
			}
		}
	}
});

function setSliderInterval(direction) {
	setCurrentTestimonial(direction == 'next');
	clearInterval(testimonialsInterval);
	testimonialsInterval = setInterval(autoSlideTestimonials, intervalTime);
}

function setCurrentTestimonial(isNext) {
	if(testimonialsSection.classList.contains('testimonials')) {
		Velocity(testimonials[currentTestimonial], {opacity: [0,1]}, {duration: 600, visibility: 'hidden'});

		currentTestimonial = isNext ? (currentTestimonial == testimonialsLength ? 0 : ++currentTestimonial) : (currentTestimonial == 0 ? testimonialsLength : --currentTestimonial);

		Velocity(testimonials[currentTestimonial], {opacity: [1,0]}, {duration: 600, visibility: 'visible'});
	}
	else
		slideTestimonial(isNext);
}

function slideTestimonial(isNext) {
	if(isNext && (currentTestimonial + (checkWidth(480) ? 0 : 1)) == testimonialsLength)
		currentTestimonial = -1;

	currentTestimonial += isNext ? 1 : (-1);

	var cardWidth = testimonials[0].offsetWidth,
		isLast = (currentTestimonial + (checkWidth(480) ? 0 : 1)) == testimonialsLength,
		gap = parseInt(window.getComputedStyle(testimonialsSlider).gap),
		slideTo = (-1 * (((cardWidth + gap) * (isLast && !checkWidth(480) ? testimonials.length : currentTestimonial)) - gap)) + (isLast && !checkWidth(480) ? testimonialsSection.offsetWidth : 0);

	testimonialsSlider.style = 'transform: translateX('+slideTo+'px); transition: 1s ease';

	testimonialButtons[0].disabled = currentTestimonial === 0;
	testimonialButtons[1].disabled = isLast;
}